module.exports = __webpack_public_path__ + "static/media/arrow_down.f200e06f.svg";